import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha';
import VeeValidate from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import axios from 'axios';
import './style.css'

Vue.use(VeeValidate);

Vue.component('App', require('./online-form/App.vue').default);
Vue.component('SerbiaOnlineForm', require('./online-form/SerbiaOnlineForm.vue').default);
Vue.component('RedemptionOnlineForm', require('./online-form/RedemptionOnlineForm.vue').default);
Vue.component('DrawOnlineForm', require('./online-form/DrawOnlineForm.vue').default);
Vue.component('Quiz', require('./quiz/Quiz.vue').default);
Vue.component('Question', require('./quiz/question/Question.vue').default);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app'
});






// WEBPACK FOOTER //
// ./src/main.js